import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Role, User } from 'src/app/models/user';

/* eslint-disable @angular-eslint/no-input-rename */
@Directive({
  selector: '[appRequiredUserRoles]',
  standalone: true,
})
export class RequiredUserRolesDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  @Input() appRequiredUserRoles: Role[];
  @Input('appRequiredUserRolesAnd') user: User;

  ngOnInit(): void {
    this.createEmbeddedViewIfHasRequiredRole();
  }

  private createEmbeddedViewIfHasRequiredRole(): void {
    if (this.appRequiredUserRoles?.length > 0 && this.user) {
      this.viewContainer.clear();
      const userHasRequiredRole = this.appRequiredUserRoles.includes(this.user.role);

      if (userHasRequiredRole) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
